export type CustomerVoicePreference = "ask" | "enabled" | "muted";

let preference: CustomerVoicePreference = "ask";
const listeners = new Set<() => void>();

export function readCustomerVoicePreference(): CustomerVoicePreference {
  return preference;
}

export function subscribeCustomerVoicePreference(
  listener: () => void,
): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setCustomerVoicePreference(
  next: CustomerVoicePreference,
): void {
  if (preference === next) return;
  preference = next;
  for (const listener of listeners) listener();
}
